import { Routes } from "@angular/router";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { AppMainComponent } from "./shared/layout/main/app.main.component";

export const mainRoutes: Routes = [
  {
    path: "",
    component: AppMainComponent,
    children: [
      { path: "", component: DashboardComponent },
      {
        path: "orders",
        loadChildren:
          "./orders/orders.module#OrdersModule",
      },
      {
        path: "branchoffices",
        loadChildren:
          "./branchoffices/branchoffices.module#BranchofficesModule",
      },
      {
        path: "trucks",
        loadChildren:
          "./trucks/trucks.module#TrucksModule",
      },
      {
        path: "supplyorders",
        loadChildren:
          "./supplyorders/supply-orders.module#SupplyOrdersModule",
      },
      {
        path: "shippingvouchers",
        loadChildren:
          "./shippingvouchers/shipping-vouchers.module#ShippingVouchersModule",
      },
      {
        path: "incomingvouchers",
        loadChildren:
          "./incomingvouchers/incoming-vouchers.module#IncomingVouchersModule",
      }
    ],
  },
  { path: "**", redirectTo: "login" },
];
